"use client";
import { useState, useEffect } from "react";
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false); // default: desktop
  useEffect(() => {
    // Safe: only runs on client
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    checkMobile(); // initial check
    // Optional: handle resize
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  return isMobile;
};
export default useIsMobile;
